import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from './AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('../views/inicio-sesion/login')),
    },
]

export const protectedRoutes = [
    {
        key: `home`,
        path: `${APP_PREFIX_PATH}/home`,
        component: React.lazy(() => import(`../views/home/Home`)),
    },
    {
        key: `form`,
        path: `${APP_PREFIX_PATH}/formulario`,
        component: React.lazy(() => import(`../components/FormTrack`)),
    },
    {
        key: "form2",
        path: `${APP_PREFIX_PATH}/form/:id`,
        component: React.lazy(() => import(`../views/form/index`))
    },
    {
        key: `cuenta`,
        path: `${APP_PREFIX_PATH}/cuenta/:id`,
        component: React.lazy(() => import(`../views/Cuenta`))
    }
]